import React, { useEffect, useState } from "react";
import "./CreateCampaignTemplate.css";
import "./nameCampaign.css";
import NameCampaign from "./NameCampaign";
import SubmitAndResetButton from "./SubmitAndResetButton";
import CampaignBudget from "./CampaignBudget";
import ABtesting from "./ABtesting";
import AdsetName from "./AdsetName";
import AdsName from "./AdsName";
import { useDispatch } from "react-redux";
import { setFormValidStatusData } from "../../redux/slices/apiSlice";
import {
  saveCampaignData,
  saveAdsetData,
  saveAdsData,
} from "../../redux/slices/apiSlice";

const CreateCampaignTemplate = ({
  currentStep,
  nextStep,
  creationRandomId,
}) => {
  const [isFormOneValid, setIsFormOneValid] = useState(false);
  const [formOneValue, setFormOneValue] = useState({});
  const [isFormTwoValid, setIsFormTwoValid] = useState(false);
  const [formTwoValue, setFormTwoValue] = useState({});
  const [isFormThreeValid, setIsFormThreeValid] = useState(false);
  const [formThreeValue, setFormThreeValue] = useState({});
  const [isFormFourValid, setIsFormFourValid] = useState(false);
  const [formFourValue, setFormFourValue] = useState({});
  const [isFormFiveValid, setIsFormFiveValid] = useState(false);
  const [formFiveValue, setFormFiveValue] = useState({});
  const buyingType = ["Auction", "Reservation"];
  const budgetTypes = ["Daily Budget", "Lifetime Budget"];
  const reactSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "12px",
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    menuList: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "12px",
    }),
  };

  const dispatch = useDispatch();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    dispatch(
      setFormValidStatusData({
        isFormOneValid,
        isFormTwoValid,
        isFormThreeValid,
        isFormFourValid,
        isFormFiveValid,
      })
    );
    setIsSubmitDisabled(
      (currentStep >= 1 && !isFormOneValid) ||
        (currentStep >= 2 && !isFormTwoValid) ||
        (currentStep >= 3 && !isFormThreeValid) ||
        (currentStep >= 4 && !isFormFourValid) ||
        (currentStep >= 5 && !isFormFiveValid)
        ? true
        : false
    );
  }, [
    isFormOneValid,
    isFormTwoValid,
    isFormThreeValid,
    isFormFourValid,
    isFormFiveValid,
    currentStep,
  ]);

  const submitFinalFormData = () => {
    if (
      isFormOneValid &&
      isFormTwoValid &&
      isFormThreeValid &&
      isFormFourValid &&
      isFormFiveValid
    ) {
      console.log(
        "  formOneValue, isFormOneValid ==========>>>>> ",
        formOneValue,
        isFormOneValid
      );
      console.log(
        "  formTwoValue, isFormTwoValid ==========>>>>> ",
        formTwoValue,
        isFormTwoValid
      );
      console.log(
        "  formThreeValue, isFormThreeValid ==========>>>>> ",
        formThreeValue,
        isFormThreeValid
      );
      console.log(
        "  formFourValue, isFormFourValid ==========>>>>> ",
        formFourValue,
        isFormFourValid
      );
      console.log(
        "  formFiveValue, isFormFiveValid , currentStep==========>>>>> ",
        formFiveValue,
        isFormFiveValid,
        currentStep
      );

      let payloadCampaign = {
        ...formOneValue,
        ...formTwoValue,
        ...formThreeValue,
        creationRandomId,
        dailyBudget:
          formTwoValue?.buyingType == "Daily Budget"
            ? formTwoValue?.campaignBudget
            : 0,
        lifetimeBudget:
          formTwoValue?.buyingType == "Lifetime Budget"
            ? formTwoValue?.campaignBudget
            : 0,
        special_ad_categories: "News",
        AB_Testing: {
          testTitle: formThreeValue.testTitle,
          testDuration: formThreeValue.testDuration,
          costPerResult: formThreeValue.costPerResult,
        },
      };

      let testAdsetData = {
        adsetId: `adset_${creationRandomId}`,
        status: "draft",
        adsetStatus: "ACTIVE",
        dailyBudget: formFourValue.budgetAmount,
        startDate:
          formFourValue.startDate || new Date().toISOString().split("T")[0],
        endDate:
          formFourValue.endDate || new Date().toISOString().split("T")[0],
        targeting: {
          ageRange: [formFourValue.minAge.value, formFourValue.maxAge.value],
          gender: formFourValue.gender.value,
          locations: formFourValue.location.map((item) => item.value),
          interests: [{ id: "1", name: formFourValue.createNewAudience.value }],
        },
        optimizationGoal: formFourValue.performanceGoal.value,
        bidAmount: formFourValue.bidAmount,
        billingEvent: formFourValue.placement,
        promotedObject: formFourValue.include.value,
        destinationType: formFourValue.languages.value,
        isSynced: formFourValue.adScheduling,
      };

      let testAdsData = {
        adsetId: `adset_${creationRandomId}`,
        status: "draft",
        creative: {
          headline: formFiveValue.AdsName,
          description: formFiveValue.AdsName,
          imageUrl: formFiveValue.urlParameters.join(", "),
          videoUrl: formFiveValue.urlParameters.join(", "),
          callToAction: formFiveValue.adSetup,
          page_id: `page_${creationRandomId}`,
          link_data: {
            message: formFiveValue.primaryText.join(", "),
            image_hash: formFiveValue.placement,
            link: formFiveValue.instagramAccount.value,
            name: formFiveValue.mediaLocation.value,
            call_to_action: {
              type: "GET_QUOTE",
              value: {
                lead_gen_form_id: formFiveValue.AdsName,
              },
            },
          },
        },
        tracking: {
          url: formFiveValue.facebookPage.value,
          pixelId: formFiveValue.multiAdvertiserAds,
        },
        isSynced: true,
      };

      dispatch(saveCampaignData(payloadCampaign));
      dispatch(
        saveAdsetData({ ...formFourValue, creationRandomId, ...testAdsetData })
      );
      dispatch(
        saveAdsData({ ...formFiveValue, creationRandomId, ...testAdsData })
      );
    }
  };

  return (
    <div className="campaign-template relative ">
      {currentStep === 1 ? (
        <NameCampaign
          setIsFormOneValid={setIsFormOneValid}
          setFormOneValue={setFormOneValue}
          formOneValue={formOneValue}
          buyingType={buyingType}
          reactSelectStyles={reactSelectStyles}
        />
      ) : currentStep === 2 ? (
        <CampaignBudget
          setIsFormTwoValid={setIsFormTwoValid}
          setFormTwoValue={setFormTwoValue}
          formTwoValue={formTwoValue}
          budgetTypes={budgetTypes}
          reactSelectStyles={reactSelectStyles}
        />
      ) : currentStep === 3 ? (
        <ABtesting
          setIsFormThreeValid={setIsFormThreeValid}
          setFormThreeValue={setFormThreeValue}
          formThreeValue={formThreeValue}
          reactSelectStyles={reactSelectStyles}
        />
      ) : currentStep === 4 ? (
        <AdsetName
          setIsFormFourValid={setIsFormFourValid}
          setFormFourValue={setFormFourValue}
          formFourValue={formFourValue}
          reactSelectStyles={reactSelectStyles}
        />
      ) : currentStep === 5 ? (
        <AdsName
          setIsFormFiveValid={setIsFormFiveValid}
          setFormFiveValue={setFormFiveValue}
          formFiveValue={formFiveValue}
          submitFinalFormData={submitFinalFormData}
          reactSelectStyles={reactSelectStyles}
        />
      ) : (
        <></>
      )}
      <div className="fixed bottom-0 w-full bg-white">
        <SubmitAndResetButton
          nextStep={nextStep}
          currentStep={currentStep}
          isDisabled={isSubmitDisabled}
          submitFinalFormData={submitFinalFormData}
        />
      </div>
    </div>
  );
};

export default CreateCampaignTemplate;
